// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { PageContent } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons/buttons';
import AddTask from 'components/models/ticket/add-task';
import FlipMove from 'components/widgets/animation/flip-move';
import Task from 'services/data/task';
import TaskComponent from 'components/models/ticket/task';


// Component
class TicketTasks extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    updateTask: PropTypes.func,
    updateTicket: PropTypes.func,
    saveNewTask: PropTypes.func,
    ticket: PropTypes.object,
    teams: PropTypes.array
  };

  constructor() {
    super();

    this.state = { showAllClosedTasks: false };
  }

  render() {
    const { ticket, updateTask, updateTicket, saveNewTask } = this.props;
    const { showAllClosedTasks } = this.state;

    if (!ticket || _.isEmpty(ticket)) return null;

    const isArchived = ticket.status === 'Archived';
    const openTasks = Task.sort(_.filter(ticket.tasks, { status: 'Active' }));
    const closedTasks = _(ticket.tasks)
      .filter({ status: 'Complete' })
      .orderBy([(task) => moment(task.completedAt).toDate()], ['desc'])
      .value();
    const maxClosedTasks = 20;
    const limitClosedTasks = closedTasks.length > maxClosedTasks && !showAllClosedTasks;
    const visibleClosedTasks = limitClosedTasks ? _.take(closedTasks, maxClosedTasks) : closedTasks;

    return (
      <PageContent className="bg-medium-blue-grey ticket">
        <div className="ticket-tasks">
          <div className="tasks open-tasks">
            { !isArchived && <AddTask saveTask={saveNewTask} updateTicket={updateTicket} ticket={ticket} cancelAddTask={_.noop} /> }
            <ul className="unstyled-list">
              <FlipMove>
                {_.map(openTasks, (task) =>
                  <TaskComponent
                    key={task.uuid}
                    task={task}
                    updateTask={(updates, ticketUpdates) => updateTask({ ..._.pick(task, ['uuid', 'ticket']), ...updates }, ticketUpdates)}
                    updateTicket={updateTicket}
                    ticket={ticket}
                    inTicket
                  />
                )}
              </FlipMove>
            </ul>
          </div>
          <div className="tasks closed-tasks">
            <ul className="unstyled-list">
              <FlipMove>
                {_.map(visibleClosedTasks, (task) =>
                  <div key={task.uuid}>
                    <TaskComponent
                      task={task}
                      updateTask={(updates, ticketUpdates) => updateTask({ ..._.pick(task, ['uuid', 'ticket']), ...updates }, ticketUpdates)}
                      updateTicket={updateTicket}
                      ticket={ticket}
                      inTicket
                    />
                  </div>
                )}

                { limitClosedTasks &&
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="mb-0 mr-3">{closedTasks.length - maxClosedTasks} more closed tasks hidden</h4>
                    <PrimaryButton onClick={() => this.setState({ showAllClosedTasks: true })}>Show All</PrimaryButton>
                  </div>
                }
              </FlipMove>
            </ul>
          </div>
        </div>
      </PageContent>
    );
  }
}

// Exports
export default connect((state) => ({
  ticket: state.tickets.ticket,
  currentUser: state.auth.currentUser,
  teams: state.pageData.teams
}))(TicketTasks);



// WEBPACK FOOTER //
// ./app/routes/ticket/sub-routes/ticket-tasks.js